import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/platen.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>S&#228;mtliche schriften und briefe series I, volume 20</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 51-52<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 29 July 1702<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (312k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Franz Ernst von Platen (29 July 1702)</title>
            <meta name="description" content="An English translation of a LETTER TO FRANZ ERNST VON PLATEN by Gottfried Wilhelm Leibniz, from 29 July 1702" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO FRANZ ERNST VON PLATEN</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A I 21, p51</b>]<br /><br />
		        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;To Count von Platen, Prime Minister of Her Electoral Highness, Hanover<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sir<span style={{float: 'right'}}>29 July 1702, Lutzenburg, near Berlin</span><br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I did not want to neglect to mention to Your Excellency that Mr Toland has come here,<a name="1" href="#note1"><sup>1</sup></a> despite the precautions that were taken.<a name="2" href="#note2"><sup>2</sup></a> Madam the Electress had Mr Braun write to him saying that he would do well not to come, but this letter was sent back by Mr Bothmer because it arrived when Mr Toland was no longer in Holland. Nothing more was heard from him, but finally he arrived, on Wednesday I believe,<a name="3" href="#note3"><sup>3</sup></a> and he informed Mr Braun of his arrival.<a name="4" href="#note4"><sup>4</sup></a> I would have been of a mind to have him told to stay incognito, but he was put up in the inn where he stayed last year and where many people of the court dine. He told Mr Braun that Mr Spanheim had recommended him to Count von Wartenberg,<a name="5" href="#note5"><sup>5</sup></a> who had presented him to the King at the Hague,<a name="6" href="#note6"><sup>6</sup></a> and that His Majesty had had the kindness to say to him that he would be delighted to find him in Berlin upon his return, should he wish to go there. The Queen was in no way inclined to have him told not to come to Lutzenburg,<a name="7" href="#note7"><sup>7</sup></a> and Madam the Electress could not and did not want to exercise an act of authority in the court of another. She also had her considerations for at least not having him told that he would do well not to speak to her, as I had wished. So he has come here, and seeing Madam the Electress in the garden, he immediately went to present her with a harangue printed by the Archbishop of York,<a name="8" href="#note8"><sup>8</sup></a> written for the coronation of the Queen, and said that this prelate had given it to him for this purpose. He also presented a letter from a Mr Clayton, Alderman in London, and even a letter from Mr Spanheim. Afterwards he walked around the promenade with the Queen and Madam the Electress, and the rest of the company. Madam the Electress seems in no way inclined to speak very much to him in private, for she rightly thinks [<b>A I 21, p52</b>] that he will not be able to give her any great insights or be of much help any more, and that putting much trust in him would be injurious to some people.
                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> John Toland (1670-1722), Irish freethinker.<br />
                <a name="note2" href="#2">2.</a> See for example a report on Toland's character prepared at the end of May 1702 by Ludwig Justus Sinold (A I 21, 30-1). According to the report, both the Archbishop of Canterbury (Thomas Tenison) and the Bishop of Salisbury (Gilbert Burnet) had warned against associating with Toland.<br />
                <a name="note3" href="#3">3.</a> 26 July 1702.<br />
                <a name="note4" href="#4">4.</a> Georg Christoph von Braun, Groom of the Chamber to Sophie.<br />
                <a name="note5" href="#5">5.</a> Johann Casimir Kolbe von Wartenberg (1643-1712), Prime Minister of Prussia.<br />
                <a name="note6" href="#6">6.</a> Friedrich I of Prussia (1657-1713).<br />
                <a name="note7" href="#7">7.</a> Queen Sophie Charlotte of Prussia (1668-1705).<br />
                <a name="note8" href="#8">8.</a> John Sharp, <em>A Sermon Preach'd at the Coronation of Queen Anne, in the Abby-Church of Westminster, April XXIII, MDCCII</em> (London, 1702).<br /><br /><br />
                &#169; Lloyd Strickland 2009. Revised 2018
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
